// vant 校验函数返回 true 表示校验通过，false 表示不通过
// 邮箱验证
const FormHlep = {
  IsEmal: email => {
    //邮箱
    return /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
      email
    );
  },
  IsPhone: phone => {
    //电话
    // return true
    // return /^(\+?1)?[2-9]\d{2}[2-9](?!10)\d{6}$/.test(phone);
    return /^(\+?1)?[2-9]\d{2}[2-9](?!10)\d{5}$/.test(phone);
  },
  IsZipCode: code => {
    //邮编
    return /^[0-9]{5}$/.test(code);
  }
};
//
export default FormHlep;
